import { isValidLayout } from '@app-store'
import { RowRender as MultiLookupRowRenderer } from '../../MultiLookupRowRender'
import { HybridLayoutLookupRowPropsType } from '../hybridLayout.types'
import { EntityLayout } from '../../../types/layout.types'
import { WORKFLOW_STATUS } from '../../../utils/constants'

export const HybridLayoutMultiLookupRow = ({
  row,
  recordId,
  fullLayout,
  formUniqueId,
  isDefaultOpen = false,
  parentKey = '',
  handleSubtotalChange,
  alwaysOpen = false,
  openAllAccordions,
  showEincome = false,
  handleEIncomeClick,
  subtotalkeys = [],
  isTaskCompleted,
  task,
  isMinHeight = true,
  isAppealTask,
}: HybridLayoutLookupRowPropsType) => {
  if (!isValidLayout(fullLayout)) {
    return null
  }

  return (
    <div>
      <MultiLookupRowRenderer
        isTaskCompleted={isTaskCompleted}
        row={row}
        dataId={recordId}
        isDefaultOpen={openAllAccordions || isDefaultOpen}
        key={row.rowId}
        layout={fullLayout as EntityLayout}
        showSubTotal={!!row?.meta?.subtotalkeys}
        formUniqueId={formUniqueId}
        parentKey={parentKey}
        handleSubtotalChange={handleSubtotalChange}
        alwaysOpen={alwaysOpen}
        showEincome={showEincome}
        handleEIncomeClick={handleEIncomeClick}
        subtotalkeys={subtotalkeys || []}
        task={task}
        isMinHeight={isMinHeight}
        isAppealTask={isAppealTask}
      />
    </div>
  )
}

export const HybridLayoutLookupRow = ({
  row,
  recordId,
  fullLayout,
  formUniqueId,
  refetchLogic,
  openAllAccordions,
  isAppealTask,
  task,
}: HybridLayoutLookupRowPropsType) => {
  return (
    <div>
      <HybridLayoutMultiLookupRow
        row={row}
        recordId={recordId}
        fullLayout={fullLayout}
        formUniqueId={formUniqueId}
        refetchLogic={refetchLogic}
        parentKey={row?.lookup_meta?.lookup_keyName ?? ''}
        openAllAccordions={openAllAccordions}
        isAppealTask={isAppealTask}
        isTaskCompleted={task?.state === WORKFLOW_STATUS?.COMPLETED}
      />
    </div>
  )
}
